<div class="w-100 ap-mb-spacing-5">
  @if (invJurisdictions().length > 0) {
    <gstar-combobox
      #comboBox
      [label]="'upsertSecurity.investmentJurisdiction' | translate"
      [options]="invJurisdictions()"
      [required]="required"
      keyProp="name"
      valueProp="investmentJurisdictionId"
      trackByKey="investmentJurisdictionId"
      [value]="value"
      [disabled]="disabled"
      (selectItem)="selectInvestmentJurisdictionHandler($event)"
      (clearValue)="clearInvestmentJurisdictionHandler()" />
  }
</div>
